import React from "react";
import Page from "../components/Page";

const Disclaimer = () => <Page title="Disclaimer">this is the Disclaimer</Page>;

export default Disclaimer;
